import { Analytics } from "utils/analytics"
import { OfferedService } from "utils/interfaces"
import { OnlineOrOffline } from "modules/BookingCommon/common/interfaces"
import { Tab } from "modules/BookingCommon/components/OnlineOrOfflineTabs/Tab"

interface Props {
    onlineService: OfferedService | undefined
    offlineService: OfferedService | undefined
    onlineOrOffline: string | undefined
    isLoading?: boolean
    onChangeOnlineOrOffline: (value: OnlineOrOffline) => void
    onChangeChooseManuallyService?: (value: boolean) => void
}

export function OnlineOrOfflineTabs({
    onlineService,
    offlineService,
    onlineOrOffline,
    isLoading = true,
    onChangeOnlineOrOffline,
    onChangeChooseManuallyService,
}: Props) {
    function handleClickOnline() {
        Analytics.psychologist_service_changed_on_click()
        onChangeOnlineOrOffline("online")
        onChangeChooseManuallyService?.(true)
    }

    function handleClickOffLine() {
        Analytics.psychologist_service_changed_on_click()
        onChangeOnlineOrOffline("offline")
        onChangeChooseManuallyService?.(true)
    }

    const showOnlineService = isLoading ? onlineService : onlineOrOffline !== "offline"
    const showOfflineService = isLoading ? offlineService : onlineOrOffline !== "online"

    return (
        <div className="booking-online-off-offline-tabs">
            <div className="booking-online-off-offline-tabs__list">
                {showOnlineService && (
                    <Tab
                        isSelected={onlineOrOffline === "online"}
                        image="person-with-laptop-emoji.png"
                        title="Онлайн"
                        onClick={handleClickOnline}
                    />
                )}
                {showOfflineService && (
                    <Tab
                        isSelected={onlineOrOffline === "offline"}
                        image="person-emoji.png"
                        title="Лично"
                        onClick={handleClickOffLine}
                    />
                )}
            </div>
        </div>
    )
}
